module.exports = __webpack_public_path__ + "img/increase.bd4910c5.svg";